import { z } from 'zod';

export const notificationsSearchRequestSchema = z.object({
  ProcessType: z.enum(['Scheduled', 'InProgress', 'Completed', 'Failed']).optional(),
  PageNumber: z.number().optional(),
  PageSize: z.number().optional(),
  OrderColumn: z.string().optional(),
  OrderType: z.string().optional(),
  SearchText: z.string().optional(),
  Topic: z.string().optional(),
  Type: z.enum(['Push', 'InApp']).optional(),
});

export const notificationsSearchResponseSchema = z.object({
  totalCount: z.number(),
  result: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      content: z.string(),
      target: z
        .object({
          topic: z.string(),
        })
        .nullable(),
      startDate: z.string(),
      processType: z.enum(['Scheduled', 'InProgress', 'Completed', 'Failed']),
      updatedDate: z.string(),
    })
  ),
});

export type NotificationsSearchRequest = z.infer<typeof notificationsSearchRequestSchema>;
export type NotificationsSearchResponse = z.infer<typeof notificationsSearchResponseSchema>;

export const createNotificationRequestSchema = z.object({
  title: z.record(z.string(), z.string()),
  content: z.record(z.string(), z.string()),
  target: z
    .object({
      topic: z.string(),
    })
    .optional(),
  startDate: z.string(),
  type: z.enum(['Push', 'InApp']),
  redirectUrl: z.string().optional(),
});

export const createNotificationResponseSchema = z.any();

export type CreateNotificationRequest = z.infer<typeof createNotificationRequestSchema>;
export type CreateNotificationResponse = z.infer<typeof createNotificationResponseSchema>;

export const updateNotificationRequestSchema = z.object({
  title: z.record(z.string(), z.string()),
  content: z.record(z.string(), z.string()),
  target: z
    .object({
      topic: z.string(),
    })
    .optional(),
  startDate: z.string(),
  type: z.enum(['Push', 'InApp']),
  redirectUrl: z.string().optional(),
});

export const updateNotificationResponseSchema = z.any();

export type UpdateNotificationRequest = z.infer<typeof updateNotificationRequestSchema>;
export type UpdateNotificationResponse = z.infer<typeof updateNotificationResponseSchema>;

export const notificationDetailResponseSchema = z.object({
  id: z.string(),
  title: z.record(z.string(), z.string()),
  content: z.record(z.string(), z.string()),
  target: z
    .object({
      topic: z.string(),
    })
    .nullable(),
  startDate: z.string(),
  processType: z.enum(['Scheduled', 'InProgress', 'Completed', 'Failed']),
  redirectUrl: z.string().nullable().optional(),
});

export type NotificationDetailResponse = z.infer<typeof notificationDetailResponseSchema>;

export const deleteNotificationResponseSchema = z.any();

export type DeleteNotificationResponse = z.infer<typeof deleteNotificationResponseSchema>;

